
import { Component, Vue } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';

import TextField from '../../../../framework/fields/TextField.vue';
import SelectField from '../../../../framework/fields/SelectField.vue';

import { sharedState } from '../../../../framework/state';
import { postResource } from '../../../../framework/client/resource';
import { getEnumerationOptions } from '../../../../framework/service/options';

import { ApplicationResource } from '../../../../../common/application/enumeration/ApplicationResource';

import { errorToast, successToast } from '../../../service/toast_service';
import { updateCachedResourceRow } from '../../../service/query_cache_service';
import { FinvoiceParserPattern } from '../../../../../common/application/model/FinvoiceParserPattern';
import { FinvoiceParserPatternType } from '../../../../../common/application/model/enums/FinvoiceParserPatternType';

@Component({
    components: { SelectField, TextField, ValidationObserver },
})
export default class AddFinvoiceParserPattern extends Vue {
    // Constants
    readonly resourceType = ApplicationResource.FINVOICE_PARSER_PATTERN;

    // Properties

    // State
    shared = sharedState;
    local = {
        row: {} as FinvoiceParserPattern,
        finvoiceParserPatternTypeOptions: [] as { id: string | undefined; label: string }[],
    };

    // Functions
    async mounted() {
        this.local.finvoiceParserPatternTypeOptions = getEnumerationOptions(
            'FinvoiceParserPatternType',
            Object.keys(FinvoiceParserPatternType),
            this,
        );
    }

    add() {
        this.addResource(false);
    }

    addAndClose() {
        this.addResource(true);
    }

    async addResource(goBack: boolean) {
        try {
            const newFinvoiceParserPattern = await postResource<FinvoiceParserPattern>(
                this.resourceType,
                this.local.row,
            );
            successToast(this, 'message.finvoiceParserPatternSaved');
            updateCachedResourceRow<FinvoiceParserPattern>(
                newFinvoiceParserPattern,
                newFinvoiceParserPattern.id,
                this.resourceType,
            );

            if (goBack) {
                this.back();
            } else {
                this.$router.replace(
                    `/${ApplicationResource.FINVOICE_PARSER_PATTERN}/${newFinvoiceParserPattern.id}/edit`,
                );
            }
        } catch (error) {
            errorToast(this);
        }
    }

    back() {
        this.$router.go(-1);
    }
}
